// extracted by mini-css-extract-plugin
export default {"avatar":"KSU0oQJ3"};